import {
  CLINICIAN_ROLES,
  INearbyPatient,
  IUserInfo,
} from "@home-health-notify/domain";
import { Group as GroupIcon } from "@mui/icons-material";
import { Box, Divider, Typography } from "@mui/material";
import { PatientHeaderDescription } from "../../../../message/messageHeader/patientGroupHeader/PatientHeaderDescription";
import { GROUP_AVATAR_SIZE } from "../../../../utils/AvatarUtils";
import { PinContentStyle } from "./AdvanceSearchMap.style";

export const NearbyPatientPinContent = ({
  patients,
  selectedDiscipline,
}: {
  patients: INearbyPatient[];
  selectedDiscipline?: CLINICIAN_ROLES;
}) => {
  return (
    <PinContentStyle data-testid="nearby-patient-pin-content">
      {patients.length > 0 &&
        patients.map((patient: INearbyPatient, index: number) => {
          const patientCast = patient;
          const patientClinician = patientCast?.clinicians || [];
          return (
            <Box key={patient.id}>
              <PatientHeaderDescription
                avatarSize={GROUP_AVATAR_SIZE.SMALL}
                name={patientCast.name}
                patientStatus={patientCast.patientStatus}
                servicesToPatient={patientCast.servicesToPatient}
                meta={patientCast?.meta}
              />
              {patientClinician && (
                <CliniciansSection
                  selectedDiscipline={selectedDiscipline}
                  clinicians={patientClinician}
                />
              )}
              {index !== patients.length - 1 && <Divider sx={{ my: 0.5 }} />}
            </Box>
          );
        })}
    </PinContentStyle>
  );
};

const CliniciansSection = ({
  clinicians,
  selectedDiscipline,
}: {
  clinicians: IUserInfo[];
  selectedDiscipline: CLINICIAN_ROLES | undefined;
}) => {
  return (
    <Box sx={{ mb: 0, mt: 0.5 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
        <GroupIcon sx={{ fontSize: 14, mr: 0.75 }} />
        <Typography variant="caption" sx={{ fontWeight: 600 }}>
          {selectedDiscipline}
        </Typography>
      </Box>
      {clinicians.length !== 0 && (
        <Typography variant="caption" sx={{ lineHeight: 1.4 }}>
          {clinicians.map(c => c.name).join(", ")}
        </Typography>
      )}
      {clinicians.length === 0 && (
        <Typography
          variant="caption"
          sx={{ fontStyle: "italic", opacity: 0.6 }}
        >
          None assigned
        </Typography>
      )}
    </Box>
  );
};
